import clsx from 'clsx'
import { View } from 'react-native'

import { Card, CardBody, type TCardProps } from '@/src/elements/card'
import { Icon } from '@/src/elements/media/Icon'
import { ICON } from '@/src/general/enums/icons'

type TSettingsCardProps = TCardProps & {
  secondaryColors?: boolean
  icon?: ICON
  contentClassName?: string
}

export const SettingsCard = ({
  children,
  className,
  contentClassName,
  icon,
  onPress,
  secondaryColors,
  ...otherProps
}: TSettingsCardProps) => (
  <Card
    shadow="sm"
    onPress={onPress}
    isHoverable={!!onPress}
    isPressable={!!onPress}
    className={clsx(secondaryColors && 'bg-secondary-bg-light', className)}
    {...otherProps}
  >
    <CardBody className="p-4 flex-row gap-3">
      {icon && (
        <Icon
          name={icon}
          className={secondaryColors ? 'text-secondary-text-contrast-default' : 'text-default-text-contrast-default'}
        />
      )}
      <View className={clsx('flex-1', contentClassName)}>{children}</View>
      {onPress && (
        <Icon
          name={ICON.CHEVRON_RIGHT}
          className={clsx('self-center', secondaryColors && 'text-secondary-text-contrast-low')}
        />
      )}
    </CardBody>
  </Card>
)
